import { render, staticRenderFns } from "./176.vue?vue&type=template&id=4b138352&scoped=true&"
var script = {}
import style0 from "./176.vue?vue&type=style&index=0&id=4b138352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b138352",
  null
  
)

export default component.exports